import React from "react";

const AboutSca = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11285_20288)">
        <path
          d="M17.4 10.2C19.39 10.2 21 8.58998 21 6.59998C21 4.60998 19.39 3 17.4 3C15.41 3 13.8 4.60998 13.8 6.59998C13.8 8.58998 15.41 10.2 17.4 10.2Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M6.60001 10.2C8.59001 10.2 10.2 8.58998 10.2 6.59998C10.2 4.60998 8.59001 3 6.60001 3C4.61001 3 3 4.60998 3 6.59998C3 8.58998 4.61001 10.2 6.60001 10.2Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M17.4 21C19.39 21 21 19.39 21 17.4C21 15.41 19.39 13.8 17.4 13.8C15.41 13.8 13.8 15.41 13.8 17.4C13.8 19.39 15.41 21 17.4 21Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M6.60001 21C8.59001 21 10.2 19.39 10.2 17.4C10.2 15.41 8.59001 13.8 6.60001 13.8C4.61001 13.8 3 15.41 3 17.4C3 19.39 4.61001 21 6.60001 21Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11285_20288">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AboutSca;
